import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ApiRequestService } from '../../services/api-request.service';
import { DatePipe } from '@angular/common';
import * as Player from "@vimeo/player/dist/player.js";

@Component({
  selector: 'preview-content',
  templateUrl: './preview-content.component.html',
  styleUrls: ['./preview-content.component.scss'],
  providers: [DatePipe]
})
export class PreviewContentComponent {
	modal_info:any = undefined;
	video:any = undefined;
	player:any = undefined;

	constructor(
		private api:ApiRequestService,
		public dialogRef: MatDialogRef<PreviewContentComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any,
		private datePipe: DatePipe

	) {
		this.modal_info = dialogData;
		this.video = dialogData.video;
		if(this.video && this.video.origin == "vimeo"){
			let idVideo = this.video.uri.replace("/videos/", "");

			try {
				window.setTimeout(()=>{
					this.player = new Player('videoPlayer', {
						//url: "https://vimeo.com/"+idVideo,
						id: idVideo,
						responsive: true
					});

					this.player.on('error', (error) => {
						console.log('Erro ao carregar o player:', error);
						alert('O vídeo não pode ser carregado. Por favor, tente novamente mais tarde.');
					});

				}, 1000);
			} catch (error) {
				console.log("Erro", error);
				
			}
		}

		if(this.video && this.video.origin == "youtube") {
			window.setTimeout(() => {
				document.getElementById("videoPlayer").innerHTML = 
					`<iframe width="100%" height="400px" 
						src="${this.video.iframe}" 
						frameborder="0" 
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
						allowfullscreen>
					</iframe>`;
				}, 1000);
		}
	}

	editContent() {

		var a: HTMLAnchorElement = document.createElement('a');
		a.href = "/minhas_aulas/edit/"+this.modal_info.content_id;
		a.target = "_blank";
		document.body.appendChild(a);
		a.click();

	}

	close(param: string) {

		this.dialogRef.close();

	}
}